import intlParse from '@control-front-end/utils/intlParse';
import store from '@control-front-end/app/src/store/index';

export default function getTranslation(mesId, values, bbcode) {
  const { translations } = store.getState();
  return intlParse({ intl: { messages: translations }, mesId, values, bbcode });
}
